import { render, staticRenderFns } from "./EcommercePaymentsChart.vue?vue&type=template&id=50ceaea4"
import script from "./EcommercePaymentsChart.vue?vue&type=script&lang=js"
export * from "./EcommercePaymentsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports